module.exports = __webpack_public_path__ + "static/media/resource-6@2x.11076677.jpg";